import { createAsyncThunk } from "@reduxjs/toolkit";
//import { updateDefaultCountry } from "store/services/countries";
import {
  addColor,
  deleteColor,
  getColor,
  updateColor,
} from "store/services/dataManagement/color";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllColorAction = createAsyncThunk(
  "color/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getColor(payload);

      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const AddColorAction = createAsyncThunk(
  "color/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { filter, onSuccess, onError, ...rest } = payload;
    try {
      const res = await addColor(rest);
      if (res.status === 1) {
        dispatch(closeAdminModal());
        const responce = await getColor(filter);
        if (responce.status === 1) {
          if (onSuccess) onSuccess();
          return fulfillWithValue(responce);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) onError();
      return rejectWithValue(error);
    }
  },
);

export const DeleteColorAction = createAsyncThunk(
  "color/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onError, onSuccess, ...rest } = payload;
      const res = await deleteColor(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        const responce = await getColor(filter);
        if (responce.status === 1) {
          if (onSuccess) onSuccess();
          return fulfillWithValue(responce);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const UpdateColorAction = createAsyncThunk(
  "color/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateColor(rest);

      if (res.status === 1) {
        if (onSuccess) onSuccess();
        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.message?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) onError();
      return rejectWithValue(error);
    }
  },
);
